// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"OrganizationModal_checkboxContainer__j2jvm","deleteButton":"OrganizationModal_deleteButton__UnXP4","loaderContainer":"OrganizationModal_loaderContainer__WCEGh"};